import { Post, posts as posts1 } from './posts';
import { posts2 } from './posts2';
import { posts3 } from './posts3';
import { posts4 } from './posts4';

export type { Post };

// All posts combined and sorted by publishIndex
export const allPosts: Post[] = [...posts1, ...posts2, ...posts3, ...posts4].sort(
  (a, b) => a.publishIndex - b.publishIndex
);
